import { createAsyncThunk } from "@reduxjs/toolkit";

export const getWalletBalance = createAsyncThunk(
    "walletBalance",
    async (userToken) => {
        const response = await fetch(
            "https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_get_walletBalance",
            {
                method: "POST",
                headers: new Headers({
                    "Authorization": `${userToken}`,
                    'Content-Type': 'application/json'
                }),
                
            }
        );
        return response.json();
    }
);